import { Link } from "@inertiajs/react";

interface Tab {
  label: string;
  href: string;
  active: boolean;
}

interface TabNavigationProps {
  tabs: Tab[];
}

const TabNavigation: React.FC<TabNavigationProps> = ({ tabs }) => (
  <div className="border-cream-200 dark:border-cream-800 w-full min-w-0 border-b">
    <nav className="-mb-px flex gap-6 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
      {tabs.map((tab) => (
        <Link
          key={tab.href}
          href={tab.href}
          className={`shrink-0 border-b-2 pb-2 text-sm font-medium whitespace-nowrap transition-colors ${
            tab.active
              ? "border-peach-500 text-peach-600 dark:text-peach-400"
              : "text-cream-600 hover:text-cream-900 dark:text-cream-400 dark:hover:text-cream-100 border-transparent"
          }`}
        >
          {tab.label}
        </Link>
      ))}
    </nav>
  </div>
);

export default TabNavigation;
